import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["searchInput", "leftItem", "assignedList", "assignedEmpty", "inputs"]

  connect() {
    this.syncInputsFromAssignedRows()
    this.refreshAssignedEmptyState()
  }

  filter() {
    const query = this.searchInputTarget.value.trim().toLowerCase()

    this.leftItemTargets.forEach((item) => {
      const haystack = item.dataset.search || ""
      item.classList.toggle("hidden", query.length > 0 && !haystack.includes(query))
    })
  }

  add(event) {
    event.preventDefault()
    const button = event.currentTarget
    if (button.disabled) return

    const articleId = button.dataset.articleId
    const articleTitle = button.dataset.articleTitle
    const articleKind = button.dataset.articleKind

    this.ensureAssignedRow(articleId, articleTitle, articleKind)
    this.markLeftItemSelected(articleId, true)
    this.syncInputsFromAssignedRows()
    this.refreshAssignedEmptyState()
  }

  remove(event) {
    event.preventDefault()
    const articleId = event.currentTarget.dataset.articleId

    this.removeAssignedRow(articleId)
    this.markLeftItemSelected(articleId, false)
    this.syncInputsFromAssignedRows()
    this.refreshAssignedEmptyState()
  }

  ensureInput(articleId) {
    if (this.findInput(articleId)) return

    const input = document.createElement("input")
    input.type = "hidden"
    input.name = "category[article_ids][]"
    input.value = articleId
    input.dataset.articleAssignmentInput = "true"
    input.dataset.articleId = articleId
    this.inputsTarget.appendChild(input)
  }

  removeInput(articleId) {
    const input = this.findInput(articleId)
    if (input) input.remove()
  }

  findInput(articleId) {
    return this.inputsTarget.querySelector(
      `[data-article-assignment-input][data-article-id="${articleId}"]`
    )
  }

  ensureAssignedRow(articleId, title, kind) {
    const existing = this.assignedListTarget.querySelector(`[data-assigned-article-id="${articleId}"]`)
    if (existing) return

    const li = document.createElement("li")
    li.dataset.assignedArticleId = articleId
    li.className = "rounded-box px-3 py-2"
    li.innerHTML = `
      <div class="flex items-center justify-between gap-2">
        <div>
          <p class="font-medium">${this.escapeHtml(title)}</p>
          <p class="text-xs text-base-content/70">
            <span class="badge badge-ghost badge-xs">${this.escapeHtml(kind)}</span>
          </p>
        </div>
        <button
          type="button"
          class="btn btn-error btn-outline btn-sm hover:text-white"
          data-action="category-article-assignment#remove"
          data-article-id="${this.escapeHtml(articleId)}"
        >
          Remove
        </button>
      </div>
    `
    this.assignedListTarget.appendChild(li)
  }

  removeAssignedRow(articleId) {
    const row = this.assignedListTarget.querySelector(`[data-assigned-article-id="${articleId}"]`)
    if (row) row.remove()
  }

  syncInputsFromAssignedRows() {
    this.inputsTarget
      .querySelectorAll('input[name="category[article_ids][]"]')
      .forEach((input) => input.remove())

    const placeholder = document.createElement("input")
    placeholder.type = "hidden"
    placeholder.name = "category[article_ids][]"
    placeholder.value = ""
    placeholder.dataset.assignmentPlaceholder = "true"
    this.inputsTarget.appendChild(placeholder)

    this.assignedListTarget
      .querySelectorAll("[data-assigned-article-id]")
      .forEach((row) => {
        const articleId = row.dataset.assignedArticleId
        const input = document.createElement("input")
        input.type = "hidden"
        input.name = "category[article_ids][]"
        input.value = articleId
        input.dataset.articleAssignmentInput = "true"
        input.dataset.articleId = articleId
        this.inputsTarget.appendChild(input)
      })
  }

  markLeftItemSelected(articleId, selected) {
    const item = this.leftItemTargets.find((entry) => entry.dataset.articleId === articleId)
    if (!item) return

    item.classList.toggle("opacity-50", selected)
    const button = item.querySelector("button[data-action*='category-article-assignment#add']")
    if (!button) return
    button.disabled = selected
  }

  refreshAssignedEmptyState() {
    const hasAssigned = this.assignedListTarget.querySelector("[data-assigned-article-id]") !== null
    this.assignedEmptyTarget.hidden = hasAssigned
  }

  escapeHtml(value) {
    const element = document.createElement("div")
    element.textContent = String(value ?? "")
    return element.innerHTML
  }
}
